/* eslint dot-notation:0 */
(function(angular) {
    'use strict';

    angular.module('um.categories').factory('categoriesService', categoryService);

    categoryService.$inject = ['$q', 'endpoints', '$http', 'wtNotifications'];

    function categoryService($q, endpoints, $http, wtNotifications) {
        return {
            getAllCategories: function(full) {
                var deferred = $q.defer();
                var apiAllCategories = angular.copy(endpoints.apiAllCategories);

                // no caching
                apiAllCategories.url += '?ts=' + Date.now();

                $http(apiAllCategories)
                    .then(function(response) {
                        // the complete list of categories with the webtrekk standard ones,
                        // has to be explicitly asked for by setting 'full' to true on the
                        // function call
                        if (_.isUndefined(full) || !full) {
                            _.remove(response.data, function(cat) {
                                return !cat.editable;
                            });
                        }

                        deferred.resolve(response.data);
                    })
                    .catch(function(error) {
                        deferred.reject(error.data);
                    });

                return deferred.promise;
            },

            getCategory: function(id) {
                var deferred = $q.defer();
                var apiCategoryDetails = angular.copy(endpoints.apiCategoryDetails);
                apiCategoryDetails.url = apiCategoryDetails.url.replace(/%categoryId/, id);

                // no caching
                apiCategoryDetails.url += '?ts=' + Date.now();

                $http(apiCategoryDetails)
                    .then(function(response) {
                        deferred.resolve(response.data);
                    })
                    .catch(function() {
                        wtNotifications.error('MSG.CATEGORY_NOT_FOUND');
                        deferred.reject('MSG.CATEGORY_NOT_FOUND');
                    });

                return deferred.promise;
            },

            createCategory: function(category) {
                var deferred = $q.defer();
                var apiCategoryCreate = angular.copy(endpoints.apiCategoryCreate);

                apiCategoryCreate.data = category;

                $http(apiCategoryCreate)
                    .then(function(response) {
                        deferred.resolve(response.config.data);
                    })
                    .catch(function(error) {
                        deferred.reject(error.data);
                    });

                return deferred.promise;
            },

            updateCategory: function(category) {
                var deferred = $q.defer();
                var apiCategoryUpdate = angular.copy(endpoints.apiCategoryUpdate);

                apiCategoryUpdate.url = apiCategoryUpdate.url.replace(/%categoryId/, category.id);
                apiCategoryUpdate.data = category;

                $http(apiCategoryUpdate)
                    .then(function(response) {
                        deferred.resolve(response.config.data);
                    })
                    .catch(function(error) {
                        deferred.reject(error.data);
                    });

                return deferred.promise;
            },

            deleteCategory: function(categoryId) {
                var deferred = $q.defer();

                var apiCategoryDelete = angular.copy(endpoints.apiCategoryDelete);
                apiCategoryDelete.url = apiCategoryDelete.url.replace(/\%categoryId/g, categoryId);
                apiCategoryDelete.data = null;

                $http(apiCategoryDelete)
                    .then(function() {
                        deferred.resolve();
                    })
                    .catch(function(error) {
                        deferred.reject(error.data);
                    });

                return deferred.promise;
            }
        };
    }
})(window.angular);
